import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AppContext } from '../containers/appContextContainer';
import { EgenkapitalWeb, SoeknadstypeWeb } from '../generated-types';
import errorTypes from '../util/gtm/errorTypes';
import restClient from '../util/web-http-client';

export const useEgenkapital = (soeknadtype: SoeknadstypeWeb) => {
    const { setError } = useContext(AppContext);
    const query = useQuery({
        queryKey: ['egenkapital'],
        queryFn: () => restClient.getEgenkapital(soeknadtype),
        retry: 1,
    });

    useEffect(() => {
        if (query.error) {
            setError({
                errorType: errorTypes.GET_EGENKAPITAL,
                errorException: query.error as RequestExceptionWithResponse,
            });
        }
    }, [query.error, setError]);

    return query;
};

export const useSaveEgenkapital = (egenkapital: EgenkapitalWeb | undefined, successCallback?: () => void) => {
    const { setError } = useContext(AppContext);
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['egenkapital'],
        mutationFn: (egenkapital: EgenkapitalWeb) => restClient.saveEgenkapital(egenkapital),
        onSuccess: (data: EgenkapitalWeb) => {
            if (egenkapital) {
                egenkapital = data;
                queryClient.setQueryData(['egenkapital'], egenkapital);
            }
            if (successCallback) {
                successCallback();
            }
        },
        onError: (error) => {
            setError({ errorType: errorTypes.SAVE_EGENKAPITAL, errorException: error as RequestExceptionWithResponse });
        },
    });
};
